/* MAXIM · Seguro para el cambio de idioma (móvil): si el formulario del tema no cambia de página,
   redirige directamente a la versión del idioma elegido. DE es el idioma principal (sin prefijo). */
(function () {
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('select[name="language_code"]')) return;
    var code = (sel.value || '').toLowerCase(), form = sel.form, left = false;
    if (!code) return;
    window.addEventListener('pagehide', function () { left = true; }, { once: true });
    setTimeout(function () {
      if (left) return;
      try { if (form) { HTMLFormElement.prototype.submit.call(form); } } catch (err) {}
      setTimeout(function () {
        if (left) return;
        var path = location.pathname.replace(/^\/(de|es|en)(?=\/|$)/i, '') || '/';
        location.href = (code === 'de' ? '' : '/' + code) + (path === '/' && code !== 'de' ? '' : path) + location.search;
      }, 900);
    }, 700);
  }, true);
})();
